import { useEffect } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { socketSubscribe } from '@namespace/socket';
import { cryptoRateActions } from '../../store/cryptoRate';
import { useBettingCurrency } from '../useBettingCurrency';

const { UPDATE_CRYPTO_RATE } = cryptoRateActions;

export const useCryptoRates = () => {
  const bettingCurrency = useBettingCurrency();
  const { crypto = {} } = useOtherSettings();
  const { isNeedLoadRates = false } = crypto;

  useEffect(() => {
    if (isNeedLoadRates) {
      socketSubscribe({
        name: 'get_crypto_rates',
        types: ['fiat2crypto_rates_updated'],
        message: {
          cmd: 'subscribe_notifications',
          data: {
            service: 'fin_engine',
            event: 'fiat2crypto_rates_updated',
            items: [bettingCurrency || 'USD']
          }
        },
        callback: ({ data }) => {
          UPDATE_CRYPTO_RATE(data);
        }
      });
    }
  }, [bettingCurrency, isNeedLoadRates]);
};
